var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.servcWorkVoucher }
        },
        [
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("零售商信息")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("零售商")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c("span", [_vm._v(_vm._s(_vm.servcWorkVoucher.buyerName))])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("业务单元")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.servcWorkVoucher.buyerBizUnitName))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("所属部门")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c("span", [_vm._v(_vm._s(_vm.servcWorkVoucher.buyerShopName))])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("卖方信息")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("卖方商户")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c("span", [_vm._v(_vm._s(_vm.servcWorkVoucher.sellerName))])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("卖方机构")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c("span", [_vm._v(_vm._s(_vm.servcWorkVoucher.sellerComName))])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("服务信息")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("是否卖方安装")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.setupFlagChange },
                      model: {
                        value: _vm.servcWorkVoucher.sellerSetupFlag,
                        callback: function($$v) {
                          _vm.$set(_vm.servcWorkVoucher, "sellerSetupFlag", $$v)
                        },
                        expression: "servcWorkVoucher.sellerSetupFlag"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("是")
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("否")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            !_vm.servcWorkVoucher.sellerSetupFlag
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label required" }, [
                    _c("label", { staticClass: "required" }, [_vm._v("服务商")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "servicerName" } },
                        [
                          _c("el-input", {
                            staticClass: "width-2x bottom-line",
                            attrs: { disabled: true },
                            model: {
                              value: _vm.servcWorkVoucher.servicerName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.servcWorkVoucher,
                                  "servicerName",
                                  $$v
                                )
                              },
                              expression: "servcWorkVoucher.servicerName"
                            }
                          }),
                          _vm._v(" "),
                          _c("i", {
                            staticClass:
                              "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                            on: { click: _vm.selectServicer }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("紧急状态")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.servcWorkVoucher.emgLevel,
                        callback: function($$v) {
                          _vm.$set(_vm.servcWorkVoucher, "emgLevel", $$v)
                        },
                        expression: "servcWorkVoucher.emgLevel"
                      }
                    },
                    _vm._l(_vm.emgLevelList, function(emgLevel) {
                      return _c("el-option", {
                        key: emgLevel.value,
                        attrs: { label: emgLevel.text, value: emgLevel.value }
                      })
                    })
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label " }, [
                _c("label", { staticClass: "required" }, [_vm._v("服务")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c("el-input", {
                    staticClass: "width-2x bottom-line",
                    attrs: { disabled: true },
                    model: {
                      value: _vm.servcWorkVoucher.servcTitle,
                      callback: function($$v) {
                        _vm.$set(_vm.servcWorkVoucher, "servcTitle", $$v)
                      },
                      expression: "servcWorkVoucher.servcTitle"
                    }
                  }),
                  _vm._v(" "),
                  _c("i", {
                    staticClass:
                      "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                    on: { click: _vm.selectServc }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("安装明细")]),
            _vm._v(" "),
            _c(
              "a",
              { staticClass: "swb-btn-link", on: { click: _vm.selectDevc } },
              [_vm._v("选择")]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table-layout" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.devcSetupItemList, border: "" }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "devcXN",
                      label: "设备编号",
                      width: "220",
                      align: "left"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "shopDeviceSvcSubNo.vendorUkno",
                      label: "商品标识码",
                      align: "left",
                      width: "220"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "shopDeviceSvcSubNo.sellerName",
                      label: "卖家名称",
                      align: "left",
                      width: "220"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "extraInfo",
                      label: "其他信息",
                      align: "left"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "asmblFlag",
                      label: "含组装商品",
                      width: "150",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(rows.row.asmblFlag ? "是" : "否"))
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "asmblDone",
                      label: "是否组装完毕",
                      width: "150",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.asmblFlag
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(rows.row.asmblDone ? "是" : "否")
                                  )
                                ])
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "asmblWhileSetup",
                      label: "安装时完成组装",
                      width: "150",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(rows.row.asmblWhileSetup ? "是" : "否")
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { align: "center", width: "80", label: "操作" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "a",
                              {
                                staticClass: "swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.removeItem(scope.$index)
                                  }
                                }
                              },
                              [_vm._v("移除")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("其他信息")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "simple-form" }, [
            _vm.showBasicClaim
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", [_vm._v("价格质量要求")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-2x" },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "fl",
                          attrs: { placeholder: "请选择" },
                          on: { change: _vm.selectBasicClaim },
                          model: {
                            value: _vm.basicClaimIndex,
                            callback: function($$v) {
                              _vm.basicClaimIndex = $$v
                            },
                            expression: "basicClaimIndex"
                          }
                        },
                        _vm._l(_vm.servcBasicClaimList, function(
                          basicClaim,
                          index
                        ) {
                          return _c("el-option", {
                            key: basicClaim.id,
                            attrs: {
                              label: basicClaim.goodsModel,
                              value: index
                            }
                          })
                        })
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("上门费")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c("el-input", {
                    staticClass: "width-2x",
                    model: {
                      value: _vm.servcWorkVoucher.toDoorFee,
                      callback: function($$v) {
                        _vm.$set(_vm.servcWorkVoucher, "toDoorFee", $$v)
                      },
                      expression: "servcWorkVoucher.toDoorFee"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("元")])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("服务费")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c("el-input", {
                    staticClass: "width-2x",
                    model: {
                      value: _vm.servcWorkVoucher.generallFee,
                      callback: function($$v) {
                        _vm.$set(_vm.servcWorkVoucher, "generallFee", $$v)
                      },
                      expression: "servcWorkVoucher.generallFee"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("元")])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [
                  _vm._v("要求响应时长")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c("el-input", {
                    staticClass: "width-2x",
                    model: {
                      value: _vm.servcWorkVoucher.yqRspTimeMi,
                      callback: function($$v) {
                        _vm.$set(_vm.servcWorkVoucher, "yqRspTimeMi", $$v)
                      },
                      expression: "servcWorkVoucher.yqRspTimeMi"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("分钟")])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [
                  _vm._v("要求到达时长")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c("el-input", {
                    staticClass: "width-2x",
                    on: { change: _vm.yqArriveTimeMiChange },
                    model: {
                      value: _vm.servcWorkVoucher.yqArriveTimeMi,
                      callback: function($$v) {
                        _vm.$set(_vm.servcWorkVoucher, "yqArriveTimeMi", $$v)
                      },
                      expression: "servcWorkVoucher.yqArriveTimeMi"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("分钟")])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [
                  _vm._v("要求完成时长")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c("el-input", {
                    staticClass: "width-2x",
                    model: {
                      value: _vm.servcWorkVoucher.yqRepairedTimeMi,
                      callback: function($$v) {
                        _vm.$set(_vm.servcWorkVoucher, "yqRepairedTimeMi", $$v)
                      },
                      expression: "servcWorkVoucher.yqRepairedTimeMi"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("分钟")])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [
                  _vm._v("要求回询时限")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c("el-input", {
                    staticClass: "width-2x",
                    model: {
                      value: _vm.servcWorkVoucher.reqTelCallTimeMi,
                      callback: function($$v) {
                        _vm.$set(_vm.servcWorkVoucher, "reqTelCallTimeMi", $$v)
                      },
                      expression: "servcWorkVoucher.reqTelCallTimeMi"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("分钟")])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("预约时间")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c("el-date-picker", {
                    staticClass: "width-2x",
                    attrs: {
                      clearable: false,
                      type: "datetime",
                      placeholder: "选择预约时间",
                      format: "yyyy-MM-dd HH:mm"
                    },
                    model: {
                      value: _vm.servcWorkVoucher.planTime,
                      callback: function($$v) {
                        _vm.$set(_vm.servcWorkVoucher, "planTime", $$v)
                      },
                      expression: "servcWorkVoucher.planTime"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("图片")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    staticStyle: { "margin-top": "6px" }
                  },
                  [
                    _c("swb-file-upload", {
                      staticClass: "fl inline-block",
                      attrs: {
                        fileGroup: "image-goods",
                        onBeforeUpload: _vm.onBeforeUpload,
                        onProgress: _vm.onProgress,
                        onDone: _vm.onUploadDone,
                        multipleFile: true
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "fl ml10" }, [
                      _vm._v("(提供上传截图,1 ~ 5张)")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.servcWorkImgList != null && _vm.servcWorkImgList.length > 0
                  ? _c(
                      "ul",
                      { staticClass: "file-area clearfix" },
                      [
                        _vm._l(_vm.servcWorkImgList, function(
                          servcWorkImg,
                          index
                        ) {
                          return [
                            _c("swb-file-item", {
                              attrs: {
                                trackKey: index,
                                fileName: servcWorkImg.fileName,
                                fileUuid: servcWorkImg.fileUuid,
                                fileBrowseUrl: servcWorkImg.fileBrowseUrl,
                                fileDownloadUrl: servcWorkImg.fileDownLoadUrl,
                                fileMd5: servcWorkImg.fileMd5,
                                deletable: true,
                                onDelete: _vm.removeFileUpload
                              }
                            })
                          ]
                        })
                      ],
                      2
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("安装说明")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c("el-input", {
                    attrs: { type: "textarea" },
                    model: {
                      value: _vm.servcWorkVoucher.troubleDesc,
                      callback: function($$v) {
                        _vm.$set(_vm.servcWorkVoucher, "troubleDesc", $$v)
                      },
                      expression: "servcWorkVoucher.troubleDesc"
                    }
                  })
                ],
                1
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-db82794e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db82794e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/workVoucher/ServcWorkVoucherSetupSave.vue
// module id = 2962
// module chunks = 0